import {useGetSettings} from '@/modules/settings/api'

/**
 * Whether patients/stock may be created manually.
 *
 * The organisation setting (`allowManualPatients` / `allowManualStock`) is the single
 * source of truth downstream — e.g. for customers (Krakow) who receive everything
 * through the hospital HL7 interface: manually created patients would have no hospital
 * identifier and break messages sent back to AMMS.
 *
 * The legacy runtime/build flags (`VITE_BLOCK_*`) act only as the defaults for the
 * settings: they apply while the synced settings value is not yet available, and
 * provision the expectation that the setting row starts from.
 */
export function useManualEntryBlocked() {
  const {settings} = useGetSettings()

  return {
    manualPatientsBlocked: settings?.allowManualPatients === false,
    manualStockBlocked: settings?.allowManualStock === false,
  }
}
